import type { TranslationMessages } from '../types';

export const reports_orders: TranslationMessages = {
  name: 'Orders Report',
  };
